import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { Card, Row, Col, Button, Spinner, Table } from 'react-bootstrap';
import md5 from 'md5';
import styles from '../../../styles.module.css';
import { getPrefix } from '../../../util/utils';
import IcmHeaderImage from '../../../components/IcmHeaderImage';
import useAvaliacao from '../../../hooks/useAvaliacao';
import useMarcapasso from '../../../hooks/useMarcapasso';
import history from '../../../services/history';
import LaudoCardHeader from '../../../components/laudos/LaudoCardHeader';

const normalizeAvaliacao = data => {
  if (!data) return null;
  return Array.isArray(data) ? data[0] || null : data;
};

export default function ReportAvaliacao() {
  const { id } = useParams();
  const location = useLocation();
  const { printing = false } = location.state || {};

  const {
    data: avaliacaoData,
    error: avaliacaoError,
    isLoading: isLoadingAvaliacao,
  } = useAvaliacao(id);
  const avaliacao = normalizeAvaliacao(avaliacaoData);
  const codMarca = avaliacao?.CODMARCA;

  const {
    data: marcapassoData,
    error: marcapassoError,
    isLoading: isLoadingMarcapasso,
  } = useMarcapasso(codMarca);
  const marcapasso = marcapassoData || {};

  const alteraFont = e => {
    let elemento = document.getElementById('cartaObs');
    let fonte = parseInt(elemento.style.fontSize);
    if (e === 'a') fonte++;
    if (e === 'd') fonte--;
    elemento.style.fontSize = fonte + 'px';
  };

  const removeDiv = divName => {
    document.getElementById(divName).style.visibility = 'hidden';
    document.getElementById('btnFonte').style.visibility = 'hidden';
    window.print();
    document.getElementById(divName).style.visibility = 'visible';
    document.getElementById('btnFonte').style.visibility = 'visible';
  };

  const isLoading = isLoadingAvaliacao || (!!codMarca && isLoadingMarcapasso);
  const hasError = avaliacaoError || marcapassoError;

  if (!id || isLoading || hasError || !avaliacao) {
    return (
      <Card className="mt-2">
        <LaudoCardHeader title="Avaliação de Marcapasso" />
        {isLoading && (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '80vh',
            }}
          >
            <Spinner animation="border" variant="dark" size="lg" />
          </div>
        )}
        {!isLoading && (
          <>
            <span
              className="text-danger text-center d-block"
              style={{ marginTop: 10 }}
            >
              {!id
                ? 'Laudo não informado. Abra pela tela de avaliação.'
                : hasError
                ? 'Erro ao carregar relatório! Tente novamente.'
                : 'Avaliação não encontrada.'}
            </span>
            <Card.Footer className="text-muted text-center">
              <Button variant="warning" onClick={() => history.goBack()}>
                Voltar
              </Button>
            </Card.Footer>
          </>
        )}
      </Card>
    );
  }

  return (
    <div>
      <div className={styles.imageReport}>
        <IcmHeaderImage variant="compact" showBlank={!printing} />
      </div>

      <div id="btnFonte" className="d-flex justify-content-end">
        <Button
          size="sm"
          variant="outline-primary"
          onClick={() => alteraFont('a')}
        >
          A+
        </Button>
        <Button
          size="sm"
          variant="outline-primary"
          onClick={() => alteraFont('d')}
        >
          A-
        </Button>
      </div>

      <LaudoCardHeader title="AVALIAÇÃO DE MARCAPASSO" />

      <div style={{ fontSize: '13px' }} className={styles.contentReport}>
        <div className="mb-2">
          <strong>Paciente: </strong>
          {`${avaliacao.CODPAC} - ${avaliacao?.NOMEPAC}`}
          <br />
          <strong>Data de Nasc: </strong>
          {`${avaliacao?.dataNasc}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong>Sexo: </strong>
          {`${avaliacao?.SEXOPAC}`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong>Idade: </strong>
          {`${avaliacao?.idadePAC} anos`}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong>Data do Implante: </strong>&nbsp;
          {`${marcapasso?.dataGer}`}
          <br />
          <strong>Convênio: </strong>
          {avaliacao?.SIGLACONV}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <strong>Código: </strong>
          {avaliacao?.CODAVALIACAO}&nbsp;&nbsp;&nbsp;
          <strong>Data da Avaliação: </strong>
          {avaliacao?.dataAvaliacao}
          <br />
          <strong>Avaliado por: Dra. </strong>
          {`${avaliacao?.Avaliou}`}
          <br />
          <strong>Médico que Solicitou: Dr. </strong>
          {`${avaliacao?.Encaminhou}`}
        </div>

        <hr />

        <Row className="mb-2">
          <Col sm={6}>
            <strong>Hospital: </strong>
            {marcapasso.HOSPITAL}
          </Col>
          <Col sm={6}>
            <strong>Tipo: </strong>
            {marcapasso.MODOESTIM}
          </Col>
        </Row>
        <Row className="mb-3">
          <Col sm={6}>
            <strong>Motivo Implante: </strong>
            {marcapasso.motivo && marcapasso.motivo[0]?.DESCRICAO}
          </Col>
          <Col sm={6}>
            <strong>Etiologia: </strong>
            {marcapasso.etiologia && marcapasso.etiologia[0]?.DESCRICAO}
          </Col>
        </Row>

        <div className="d-flex justify-content-center mb-3">
          <div style={{ width: '80%' }}>
            <h6 className="text-center font-weight-bold mb-1">GERADOR</h6>
            <Table bordered size="sm" className="text-center mb-0 style-table">
              <tbody>
                <tr>
                  <td
                    className="font-weight-bold align-middle bg-light"
                    style={{ width: '15%' }}
                  >
                    Fabricante:
                  </td>
                  <td className="align-middle" style={{ width: '35%' }}>
                    {marcapasso.CODFABGER}
                  </td>
                  <td
                    className="font-weight-bold align-middle bg-light"
                    style={{ width: '15%' }}
                  >
                    Dt Impl:
                  </td>
                  <td className="align-middle" style={{ width: '35%' }}>
                    {marcapasso.dataGer}
                  </td>
                </tr>
                <tr>
                  <td className="font-weight-bold align-middle bg-light">
                    Modelo:
                  </td>
                  <td className="align-middle">{marcapasso.CODMODGER}</td>
                  <td className="font-weight-bold align-middle bg-light">
                    Série:
                  </td>
                  <td className="align-middle">{marcapasso.SERIEGER}</td>
                </tr>
              </tbody>
            </Table>
          </div>
        </div>

        <Row className="mb-3">
          <Col sm={6}>
            <h6 className="text-center font-weight-bold mb-1">ELETRODOS</h6>
            <Table bordered size="sm" className="text-center mb-0 style-table">
              <thead>
                <tr>
                  <th colSpan="4" className="bg-light">
                    Marcapasso
                  </th>
                </tr>
                <tr>
                  <th></th>
                  <th>Atrial</th>
                  <th>VD</th>
                  <th>VE</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="font-weight-bold bg-light text-left">
                    Fabricante:
                  </td>
                  <td>{marcapasso.CODFABELAT}</td>
                  <td>{marcapasso.CODFABELVE}</td>
                  <td>{marcapasso.CODFABELVEESQ}</td>
                </tr>
                <tr>
                  <td className="font-weight-bold bg-light text-left">
                    Modelo:
                  </td>
                  <td>{marcapasso.CODMODELAT}</td>
                  <td>{marcapasso.CODMODELVE}</td>
                  <td>{marcapasso.CODMODELVEESQ}</td>
                </tr>
                <tr>
                  <td className="font-weight-bold bg-light text-left">
                    Dt Impl:
                  </td>
                  <td>{marcapasso.dataElAt}</td>
                  <td>{marcapasso.dataElVEDir}</td>
                  <td>{marcapasso.dataElVEEsq}</td>
                </tr>
                <tr>
                  <td className="font-weight-bold bg-light text-left">
                    Série:
                  </td>
                  <td>{marcapasso.SERIEELAT}</td>
                  <td>{marcapasso.SERIEELVE}</td>
                  <td>{marcapasso.SERIEELVEESQ}</td>
                </tr>
              </tbody>
            </Table>
          </Col>

          <Col sm={6}>
            <h6 className="text-center font-weight-bold mb-1">
              AVALIAÇÃO NO IMPLANTE
            </h6>
            <Table bordered size="sm" className="text-center mb-0 style-table">
              <thead>
                <tr>
                  <th rowSpan="2" className="align-middle bg-light"></th>
                  <th colSpan="2" className="bg-light">
                    Atrial
                  </th>
                  <th colSpan="2" className="bg-light">
                    VD
                  </th>
                  <th colSpan="2" className="bg-light">
                    VE
                  </th>
                </tr>
                <tr>
                  <th style={{ fontSize: '11px' }}>UNI</th>
                  <th style={{ fontSize: '11px' }}>BIP</th>
                  <th style={{ fontSize: '11px' }}>UNI</th>
                  <th style={{ fontSize: '11px' }}>BIP</th>
                  <th style={{ fontSize: '11px' }}>UNI</th>
                  <th style={{ fontSize: '11px' }}>BIP</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="font-weight-bold bg-light text-left">
                    Limiar
                  </td>
                  <td>{marcapasso.LIMIARAT}</td>
                  <td>{marcapasso.LIMIARATBI}</td>
                  <td>{marcapasso.LIMIARVE}</td>
                  <td>{marcapasso.LIMIARVDBI}</td>
                  <td>{marcapasso.LIMIARVESQUNI}</td>
                  <td>{marcapasso.LIMIARVESQBI}</td>
                </tr>
                <tr>
                  <td className="font-weight-bold bg-light text-left">
                    Resistência
                  </td>
                  <td>{marcapasso.RESITAT}</td>
                  <td>{marcapasso.RESISTATBI}</td>
                  <td>{marcapasso.RESITVE}</td>
                  <td>{marcapasso.RESISTVDBI}</td>
                  <td>{marcapasso.RESISTVESQUNI}</td>
                  <td>{marcapasso.RESISTVESQBI}</td>
                </tr>
                <tr>
                  <td className="font-weight-bold bg-light text-left">
                    Onda P/R
                  </td>
                  <td>{marcapasso.ONDAP}</td>
                  <td>{marcapasso.ONDAPBI}</td>
                  <td>{marcapasso.ONDAR}</td>
                  <td>{marcapasso.ONDARVDBI}</td>
                  <td>{marcapasso.ONDARVESQUNI}</td>
                  <td>{marcapasso.ONDARVESQBI}</td>
                </tr>
                <tr>
                  <td className="font-weight-bold bg-light text-left">
                    Slew Rate
                  </td>
                  <td>{marcapasso.SLEWRATEATUNI}</td>
                  <td>{marcapasso.SLEWRATEATBI}</td>
                  <td>{marcapasso.SLEWRATEVDUNI}</td>
                  <td>{marcapasso.SLEWRATEVDBI}</td>
                  <td>{marcapasso.SLEWRATEVEUNI}</td>
                  <td>{marcapasso.SLEWRATEVEBI}</td>
                </tr>
              </tbody>
            </Table>
          </Col>
        </Row>

        <hr />

        <strong>Avaliação do Implante de Marcapasso: </strong>
        <br />
        <div className="row">
          <div style={{ fontSize: 17 }} id="cartaObs" className="col-12">
            <div className={styles.preContent}>{avaliacao.CARTA}</div>
          </div>
        </div>

        <hr />

        <div className="text-center">
          <Card.Body>
            <div className={styles.signatureReport}>
              <i>Conferido e assinado eletronicamente por: </i>
              <br />
              <strong>
                {getPrefix(avaliacao?.CODAVALIOU)} {avaliacao.Avaliou}
              </strong>
              <br />
              <i>
                Assinatura Digital: {md5(JSON.stringify(avaliacao.CARTA || ''))}
              </i>
            </div>
          </Card.Body>
          <div id="removeMe" className="text-muted">
            <Button onClick={() => removeDiv('removeMe')}>Imprimir</Button>
          </div>
        </div>
      </div>
    </div>
  );
}
